import Loading from '@/shared/components/Carregando';
import { GetDashboardDia } from '@/modules/home/dashboards.service';
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { DashboardResumoDia } from '@/api.types';

export interface parametros {
  dia: Date;
}

export default function TabelaTotais(props: parametros) {
  const [registros, setRegistros] = useState<DashboardResumoDia>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (props.dia) {
      GetDashboardDia(
        new Date(
          props.dia.getUTCFullYear(),
          props.dia.getUTCMonth(),
          props.dia.getUTCDate(),
        ),
      )
        .then((result) => {
          setRegistros(result);
          setLoading(false);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }, [props.dia]);

  if (loading) return Loading();

  return (
    <>
      <dl className="row">
        <dt className="col-sm-4" title="Trabalhando.">
          Atuando:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.atuando}</dd>
        <dt className="col-sm-4" title="Férias.">
          Férias:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.ferias}</dd>
        <dt className="col-sm-4" title="Folga.">
          Folgas:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.folgas}</dd>
        <dt className="col-sm-4" title="Dia abonado.">
          Abonos:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.abonos}</dd>
        <dt className="col-sm-4" title="Licença.">
          Licenças:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.licencas}</dd>
        <dt className="col-sm-4" title="Não possui data de exoneração.">
          Ativos:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.ativos}</dd>
        <dd>
          <hr className="mb-0 pb-0" />
        </dd>
        <dt className="col-sm-4" title="Cadastrado no sistema.">
          No Sistema:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.nosistema}</dd>
        <dt className="col-sm-4" title="Com data de exoneração.">
          Inativos:{' '}
        </dt>
        <dd className="col-sm-2">{registros?.inativos}</dd>
        {/* <dt className="col-sm-4">Afastados: </dt>
				<dd className="col-sm-2">{registros?.afastados}</dd> */}
      </dl>
    </>
  );
}
